import { BASE_URL } from "config";
import * as base from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/sauna/`,
    detail: (id) => `${BASE_URL}/api/v1/sauna/${id}/`,
};

export const saunaListLoad = (token, payload) => base.ListLoad(endpoints.list, token, payload);
export const saunaDetailLoad = (token, { id }) => base.DetailLoad(endpoints.detail, token, { id });
export const saunaUpdate = (token, data) => base.Update(endpoints.list, endpoints.detail, token, data);
export const saunaDelete = (token, data) => base.Delete(endpoints.detail, token, data);
